// Handles "All" logic for multi-select dropdowns.
export { handleMultiSelectWithAll } from "../../shared/helpers/filterAllHelper";

export function filterCancelled(items: any) {
  return items
    ?.map((item: any) => {
      // If item has children, process them recursively
      if (item.children) {
        return {
          ...item,
          children: filterCancelled(item.children),
        };
      }
      return item;
    })
    ?.filter((item: any) => item.status !== "cancelled_by_user" && item.status !== "Cancelled"); // Remove items with status "cancelled_by_user"
}
